import { render, staticRenderFns } from "./employeeArchiveDetail.vue?vue&type=template&id=6a26e243&scoped=true"
import script from "./employeeArchiveDetail.vue?vue&type=script&lang=js"
export * from "./employeeArchiveDetail.vue?vue&type=script&lang=js"
import style0 from "./employeeArchiveDetail.vue?vue&type=style&index=0&id=6a26e243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a26e243",
  null
  
)

export default component.exports